module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [(_vm.images === 'loading') ? _c('div', {
    staticClass: "loader"
  }) : (_vm.images === false) ? _c('div', {
    staticClass: "error-msg"
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_vm._v("\n      It seems there are no images to display.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Please check your internet connection.\n    ")])]) : _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "image"
    }, [_c('a', {
      staticClass: "image__wrap",
      attrs: {
        "href": _vm.getImage(image.acf.image.url),
        "title": image.title.rendered,
        "target": "_blank"
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.getResponsiveImage(image.acf.image.sizes)),
        expression: "getResponsiveImage(image.acf.image.sizes)"
      }],
      attrs: {
        "alt": image.title.rendered
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "image__download",
      attrs: {
        "href": _vm.getImage(image.acf.image.url)
      }
    }, [_c('span', {
      staticClass: "icon-download",
      attrs: {
        "target": "_blank"
      }
    }), _vm._v(" Download")])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2439fd08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Images.vue
// module id = 43
// module chunks = 1